module.exports = __webpack_public_path__ + "static/media/shopify.f1eed0de.svg";